import { UserRole } from '@/api-models/UserRole';
import { useAuth } from '@/contexts/auth-context';

/**
 * Platform-level Zooid-staff gate (same check as `AdminGuard` / `ToolCallRow`) — NOT the
 * team-level space admin. Raw provider output and stack-trace-ish details are only meaningful to
 * staff; everyone else sees the clean message alone.
 */
function useIsStaff(): boolean {
  const { me } = useAuth();
  return me.role === UserRole.Admin;
}

/** Collapsible raw error output, rendered only for staff. Returns nothing for other users. */
export function StaffDetails({ details }: { details: string | null | undefined }) {
  const isStaff = useIsStaff();
  if (!isStaff || !details) return null;
  return (
    <pre className="mt-2 max-h-48 overflow-auto rounded-md bg-surface-2 p-2 font-mono text-2xs whitespace-pre-wrap text-fg-secondary">
      {details}
    </pre>
  );
}
